export const API_ENDPOINTS = {
  CURRENT_WEATHER: "weather",
  FIND: "find",
  ONECALL: "onecall",
  FORCAST_30_DAYS: "/forecast/climate",
  GET_LAT_LON: "direct",
};
